module.exports = __webpack_public_path__ + "static/sw-card-front-b5fc962ac32943952f6aad2079ba27be.png";